
import React from "react";
import ReactPaginate from "react-paginate";
import styles from "./CommonPagination.module.scss";
import { useStateContext } from "../../../Context/StateContext";
import { scrollToTop } from "../../../CloudStorage/CommonFunction";
import { useAllFilterBaseContext } from "../../../Context/AllFilterBaseContext";

function CommonPagination({ totalitemcounts, size, pageNumber, setPageNumber }) {
    // const { state, setPageNumber } = useAllFilterBaseContext();
    // const { pageNumber } = state;

    const pageCount = Math.ceil(totalitemcounts / size);

    // If there is only one page or fewer items than the size, hide pagination
    if (pageCount <= 1) {
        return null;
    }

    const handlePageClick = (event) => {
        setPageNumber(event.selected);
        scrollToTop();
    };

    return (
        <div className={styles["pagination-container"]}>
            <ReactPaginate
                breakLabel="..."
                nextLabel={
                    <div className={styles.labelWithImage} style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                        Next
                        <i class="fa-solid fa-right-long" style={{ paddingTop: '4px' }}></i>

                    </div>
                }
                onPageChange={handlePageClick}
                pageRangeDisplayed={1}
                pageCount={pageCount}
                previousLabel={
                    <div className={styles.labelWithImage} style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                        <i class="fa-solid fa-left-long" style={{ paddingTop: '4px' }}></i>
                        Prev
                    </div>
                }
                marginPagesDisplayed={1}
                containerClassName="pagination"
                activeClassName={styles.active}
                initialPage={pageNumber}
                forcePage={pageNumber}
            />
        </div>
    );
}

export default CommonPagination;
